import React, { useEffect, useState } from "react";
import { Button, Layout, Radio, Select, Tabs } from "antd";
import "./ProjectDashboard.css";
import AISurveyIcon from "../../../assets/img/ai-survey-i.png";
import AISurveyBuilderIcon from "../../../assets/img/survey-builder-i.png";
import AITranslationIcon from "../../../assets/img/ai-translation-i.png";
import PrintIcon from "../../../assets/img/printIcon.png";
import ProjectPeriodIcon from "../../../assets/img/projectPeriod.png";
import ChartIcon from "../../../assets/img/chart.png";
import Question from "../../../assets/img/questionsImg.png";
import Timeline from "../../../assets/img/timeline.png";
import EditProject from "../../../assets/img/edit-project.png";
import TranslationActivity from "../../../assets/img/transaltionActivity.png";
import ReverseOrder from "../../../assets/img/reverseOrdered.png";
import DataCleaning from "../../../assets/img/p-dataCleaning.png";
import AITranslation from "../../../assets/img/p-aiTranslation.png";
import DocumentInsight from "../../../assets/img/p-documentInsights.png";
import BalancedScorecard from "../../../assets/img/p-balancedScorecard.png";
import Member from "../../../assets/img/member.png";
import Location from "../../../assets/img/location.png";
import Dashboards from "../../../assets/img/dashboards.png";
import AITranslationBg from "../../../assets/img/ai-translation-bg.png";
import DocumentsBg from "../../../assets/img/documents-bg.png";
import TeamMembersBg from "../../../assets/img/team-members-bg.png";
import {
  UserOutlined,
  GlobalOutlined,
  StarFilled,
  EyeOutlined,
  ArrowRightOutlined,
  DownloadOutlined,
  ClearOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import { getDashboards } from "../../Dashboard/services/dashboard.service";
import {
  getScorecard,
  ApiScorecardFull,
} from "../../BalancedScorecard/balancedScorecard.service";
import { DashboardLayoutProps } from "../../../types/types";
import {
  getAuditLogs,
  AuditLogItem,
} from "../../AuditTrails/auditTrails.service";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { get } from "../../../utils/apiUtils";
import { Pie, Doughnut, Line, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ChartData,
  ChartOptions,
  ArcElement,
  PointElement,
  LineElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import SurveyLineChart from "../../../hooks/surveyLineChart";
import TranslationVolumeChart from "../../../hooks/translateVolumeChart";
import {
  setHomeProjectId,
  fetchHomeSummary,
} from "../../../components/DocProcessing/Home/home.slice";
import { useDispatch, useSelector } from "react-redux";
import {
  setProjectId,
  // setMonth, setYear, // nëse vendos filtra për counts
  fetchDocCounts,
} from "../../../components/DocProcessing/Analyze/analyze.slice";
import { AnyAction, ThunkDispatch } from "@reduxjs/toolkit";
import { RootState } from "../../../store/store";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
);

const { Content } = Layout;
const { TabPane } = Tabs;

const ProjectDashboard: React.FC = () => {
  const { t } = useTranslation("projects");
  const { id: projectId } = useParams();
  const navigate = useNavigate();

  // const dispatch = useDispatch();
  const dispatch = useDispatch<ThunkDispatch<RootState, unknown, AnyAction>>();
  const summary = useSelector((s: any) => s.home.summary);

  const {
    internal,
    external,
    loading: countsLoading,
    error: countsError,
  } = useSelector((s: any) => s.analyze.counts);

  const [isLoading, setIsLoading] = useState(false);
  const [surveyData, setSurveyData] = useState<any>(null);
  const [selectedDate, setSelectedDate] = useState("start");
  const [viewOption, setViewOption] = useState<"Month" | "Week">("Month");
  const [viewOptionForTranslation, setViewOptionForTranslation] = useState<
    "Month" | "Week"
  >("Month");
  const [chartTypeForTranslation, setChartTypeForTranslation] = useState<
    "bar" | "pie"
  >("bar");
  const [chartData, setChartData] = useState<ChartData<"line">>({
    labels: [],
    datasets: [],
  });
  const [generatedSurveysPieData, setGeneratedSurveysPieData] = useState<any>({
    labels: [],
    datasets: [{ data: [], backgroundColor: [], hoverBackgroundColor: [] }],
  });
  const [generatedTranslationsPieData, setGeneratedTranslationsPieData] =
    useState<any>({
      labels: [],
      datasets: [{ data: [], backgroundColor: [], hoverBackgroundColor: [] }],
    });

  const [progress, setProgress] = useState(0);
  const [totalDays, setTotalDays] = useState(0);
  const [elapsedDays, setElapsedDays] = useState(0);
  const [isReversed, setIsReversed] = useState(false);
  const [isTranslationOrderReversed, setIsTranslationOrderReversed] =
    useState(false);

  const currentYear = new Date().getFullYear().toString();

  const [selectedYear, setSelectedYear] = useState<string>(currentYear);
  const [selectedYearForTranslation, setSelectedYearForTranslation] =
    useState<string>(currentYear);
  const [surveyYears, setSurveyYears] = useState<string[]>([]);
  const [translationYears, setTranslationYears] = useState<string[]>([]);
  const [translationData, setTranslationData] = useState<any>(null);

  const [translationVolumeData, setTranslationVolumeData] = useState<
    ChartData<"bar">
  >({
    labels: [],
    datasets: [],
  });

  const [pinnedDashboards, setPinnedDashboards] = useState<
    DashboardLayoutProps[]
  >([]);
  const [totalDashboards, setTotalDashboards] = useState(0);
  const [recentActivity, setRecentActivity] = useState<AuditLogItem[]>([]);

  const [scorecard, setScorecard] = useState<ApiScorecardFull | null>(null);
  const [bscLoading, setBscLoading] = useState(false);

  console.log("project");

  const timeAgo = (isoString: string): string => {
    const diff = Math.floor(
      (Date.now() - new Date(isoString).getTime()) / 1000,
    );
    if (diff < 60) return t("dashboard.justNow");
    if (diff < 3600)
      return t("dashboard.minutesAgo", { count: Math.floor(diff / 60) });
    if (diff < 86400)
      return t("dashboard.hoursAgo", { count: Math.floor(diff / 3600) });
    if (diff < 604800)
      return t("dashboard.daysAgo", { count: Math.floor(diff / 86400) });
    return dayjs(isoString).format("MMM D, YYYY");
  };

  useEffect(() => {
    if (!projectId) return;
    const stored = localStorage.getItem(`pinned_dashboards_${projectId}`);
    const pinnedIds: string[] = stored ? JSON.parse(stored) : [];

    getDashboards({ projectId })
      .then((response) => {
        const all = response || [];
        setTotalDashboards(all.length);
        if (pinnedIds.length === 0) return;
        const mapped: DashboardLayoutProps[] = all
          .filter((item: any) => pinnedIds.includes(item.id))
          .map((item: any) => ({
            key: item.id,
            id: item.id,
            dashboard_name: item.name || t("dashboard.untitledDashboard"),
            document_type: item.document_type || "-",
            date: item.created_at
              ? new Date(item.created_at).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })
              : "",
            header_config: item.header_config ?? {},
            footer_config: item.footer_config ?? {},
          }));
        setPinnedDashboards(mapped);
      })
      .catch(() => {});

    getAuditLogs({ project_id: projectId, page_size: 5 })
      .then((res) => setRecentActivity(res.items || []))
      .catch(() => {});
  }, [projectId]);

  useEffect(() => {
    if (!projectId) return;
    setBscLoading(true);
    getScorecard(projectId)
      .then((data) => setScorecard(data))
      .catch(() => setScorecard(null))
      .finally(() => setBscLoading(false));
  }, [projectId]);

  const trafficColor = (tl: string | null | undefined) => {
    if (tl === "green") return "#10b981";
    if (tl === "yellow") return "#f59e0b";
    if (tl === "red") return "#ef4444";
    return "#d1d5db";
  };

  const toggleReverse = () => setIsReversed((v) => !v);
  const toggleTranslationOrder = () => setIsTranslationOrderReversed((v) => !v);

  const getYearsFromItems = (items: any[], dateKey: string) => {
    const years = new Set<string>();
    items.forEach((item) => {
      const d = new Date(item[dateKey]);
      if (!isNaN(d.getTime())) {
        years.add(d.getFullYear().toString());
      }
    });
    return Array.from(years).sort();
  };

  /* -------- Bind projectId në slice & merre counts -------- */
  useEffect(() => {
    dispatch(setProjectId(projectId ?? null));
    dispatch(setHomeProjectId(projectId ?? null));
  }, [dispatch, projectId]);

  useEffect(() => {
    if (projectId) {
      dispatch(fetchDocCounts());
      dispatch(fetchHomeSummary({ projectId }));
    }
    // nëse shton setMonth/setYear, shtoji në deps këtu
  }, [dispatch, projectId]);

  /* -------- Fetch survey & translation meta -------- */
  useEffect(() => {
    const fetchSurveyData = async () => {
      try {
        setIsLoading(true);
        const response = await get<any>(`get-surveys-for-dashboard`, {
          params: {
            language_id: "ecfb845a-86f0-476c-a4df-f101d35a96f9",
            project_id: projectId,
          },
        });
        if (response.type === "success") setSurveyData(response.data);
      } catch (e) {
        console.error("Error fetching survey data:", e);
      } finally {
        setIsLoading(false);
      }
    };

    const fetchTranslationData = async () => {
      try {
        const response = await get<any>(`get-translations-for-dashboard`, {
          params: { project_id: projectId },
        });
        if (response.type === "success") setTranslationData(response.data);
      } catch (e) {
        console.error("Failed to fetch translation data:", e);
      }
    };

    if (projectId) {
      fetchSurveyData();
      fetchTranslationData();
    }
  }, [projectId]);

  /* -------- Build Translation chart data -------- */
  useEffect(() => {
    if (!translationData) return;

    const { translations } = translationData.metadata;

    // vite për dropdown e translation-it
    const years = getYearsFromItems(translations || [], "created_at");
    setTranslationYears(years);
    if (years.length && !years.includes(selectedYearForTranslation)) {
      setSelectedYearForTranslation(years[years.length - 1]);
    }

    const months = [
      t("dashboard.charts.months.january"),
      t("dashboard.charts.months.february"),
      t("dashboard.charts.months.march"),
      t("dashboard.charts.months.april"),
      t("dashboard.charts.months.may"),
      t("dashboard.charts.months.june"),
      t("dashboard.charts.months.july"),
      t("dashboard.charts.months.august"),
      t("dashboard.charts.months.september"),
      t("dashboard.charts.months.october"),
      t("dashboard.charts.months.november"),
      t("dashboard.charts.months.december"),
    ];
    const weeks = [1, 2, 3, 4].map((n) => t("dashboard.charts.week", { n }));

    const monthlyCounts = new Array(12).fill(0);
    const weeklyCounts = new Array(4).fill(0);

    translations.forEach((t: any) => {
      const d = new Date(t.created_at);
      if (d.getFullYear().toString() === selectedYearForTranslation) {
        if (viewOptionForTranslation === "Month") {
          monthlyCounts[d.getMonth()] += 1;
        } else {
          const idx = Math.floor((d.getDate() - 1) / 7);
          weeklyCounts[idx] += 1;
        }
      }
    });

    setTranslationVolumeData({
      labels: viewOptionForTranslation === "Month" ? months : weeks,
      datasets: [
        {
          label: t("dashboard.charts.translationsIn", {
            year: selectedYearForTranslation,
          }),
          data:
            viewOptionForTranslation === "Month" ? monthlyCounts : weeklyCounts,
          backgroundColor: "#5B8CDB",
          borderColor: "#5B8CDB",
        },
      ],
    });

    const pieColors = [
      "#FF6384",
      "#36A2EB",
      "#FFCE56",
      "#4BC0C0",
      "#9966FF",
      "#FF9F40",
      "#FF6384",
      "#36A2EB",
      "#FFCE56",
      "#4BC0C0",
      "#9966FF",
      "#FF9F40",
    ];
    const pieLabels = viewOptionForTranslation === "Month" ? months : weeks;
    const pieData =
      viewOptionForTranslation === "Month" ? monthlyCounts : weeklyCounts;
    const nonZeroIdx = pieData
      .map((v, i) => (v > 0 ? i : -1))
      .filter((i) => i >= 0);
    setGeneratedTranslationsPieData({
      labels: nonZeroIdx.length
        ? nonZeroIdx.map((i) => pieLabels[i])
        : pieLabels,
      datasets: [
        {
          data: nonZeroIdx.length ? nonZeroIdx.map((i) => pieData[i]) : pieData,
          backgroundColor: nonZeroIdx.length
            ? nonZeroIdx.map((i) => pieColors[i])
            : pieColors,
          hoverBackgroundColor: nonZeroIdx.length
            ? nonZeroIdx.map((i) => pieColors[i])
            : pieColors,
        },
      ],
    });
  }, [translationData, selectedYearForTranslation, viewOptionForTranslation]);

  const translationVolumeChartOptions: ChartOptions<"bar"> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
      title: { display: false },
    },
    scales: {
      x: {
        reverse: isTranslationOrderReversed,
        title: {
          display: true,
          text:
            viewOptionForTranslation === "Month"
              ? t("dashboard.charts.monthsAxis")
              : t("dashboard.charts.weeksAxis"),
        },
      },
      y: {
        beginAtZero: true,
        title: { display: true, text: t("dashboard.charts.translationsAxis") },
      },
    },
  };

  const surveyLengthDistribution = surveyData?.surveys_metadata
    ?.survey_length_distribution || {
    "5-10": 0,
    "10-20": 0,
    "20+": 0,
  };

  const totalQuantitativeQuestions =
    surveyData?.surveys_metadata?.total_quantitative_questions || 0;
  const totalQualitativeQuestions =
    surveyData?.surveys_metadata?.total_qualitative_questions || 0;

  const pieData = {
    labels: [
      t("dashboard.charts.quantitative"),
      t("dashboard.charts.qualitative"),
    ],
    datasets: [
      {
        data: [totalQuantitativeQuestions, totalQualitativeQuestions],
        backgroundColor: ["#CAE2FF", "#F4D9FF"],
        hoverBackgroundColor: ["#CAE2FF", "#F4D9FF"],
      },
    ],
  };

  const pieOptions = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "right" as const,
        labels: { font: { size: 13 }, boxWidth: 14, padding: 10 },
      },
    },
  };

  const [pieDataTextExcelJson, setPieDataTextExcelJson] = useState<any>({
    labels: [
      t("dashboard.translationTypes.text"),
      t("dashboard.translationTypes.excel"),
      t("dashboard.translationTypes.json"),
    ],
    datasets: [
      {
        data: [0, 0, 0],
        backgroundColor: ["#CAE2FF", "#4a90e2", "#F4D9FF"],
        hoverBackgroundColor: ["#CAE2FF", "#4a90e2", "#F4D9FF"],
      },
    ],
  });

  const chartOptions: ChartOptions<"line"> = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: {
        display: true,
        text: t("dashboard.charts.surveysOverTimeTitle"),
      },
    },
    scales: {
      y: { beginAtZero: true, ticks: { stepSize: 1 } },
      x: { reverse: isReversed },
    },
  };

  useEffect(() => {
    if (!surveyData) return;

    // vite për dropdown e surveys
    const surveys = surveyData.surveys_metadata?.surveys_with_questions || [];
    const years = getYearsFromItems(surveys, "created_at");
    setSurveyYears(years);
    if (years.length && !years.includes(selectedYear)) {
      setSelectedYear(years[years.length - 1]);
    }

    const months = [
      t("dashboard.charts.months.january"),
      t("dashboard.charts.months.february"),
      t("dashboard.charts.months.march"),
      t("dashboard.charts.months.april"),
      t("dashboard.charts.months.may"),
      t("dashboard.charts.months.june"),
      t("dashboard.charts.months.july"),
      t("dashboard.charts.months.august"),
      t("dashboard.charts.months.september"),
      t("dashboard.charts.months.october"),
      t("dashboard.charts.months.november"),
      t("dashboard.charts.months.december"),
    ];
    const weeks = [1, 2, 3, 4].map((n) => t("dashboard.charts.week", { n }));

    const monthlyCounts = new Array(12).fill(0);
    const weeklyCounts = new Array(4).fill(0);

    surveyData.surveys_metadata.surveys_with_questions.forEach(
      (survey: any) => {
        const createdAt = new Date(survey.created_at);
        if (createdAt.getFullYear().toString() === selectedYear) {
          if (viewOption === "Month") {
            monthlyCounts[createdAt.getMonth()] += 1;
          } else {
            const weekIndex = Math.floor((createdAt.getDate() - 1) / 7);
            weeklyCounts[weekIndex] += 1;
          }
        }
      },
    );

    setChartData({
      labels: viewOption === "Month" ? months : weeks,
      datasets: [
        {
          label: t("dashboard.charts.surveysGeneratedIn", {
            year: selectedYear,
          }),
          data: viewOption === "Month" ? monthlyCounts : weeklyCounts,
          fill: false,
          backgroundColor: "rgba(75,192,192,1)",
          borderColor: "#4a1c96",
        },
      ],
    });

    setGeneratedSurveysPieData({
      labels: viewOption === "Month" ? months : weeks,
      datasets: [
        {
          label: t("dashboard.charts.surveyDistributionIn", {
            year: selectedYear,
          }),
          data: viewOption === "Month" ? monthlyCounts : weeklyCounts,
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#4BC0C0",
            "#9966FF",
            "#FF9F40",
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#4BC0C0",
            "#9966FF",
            "#FF9F40",
          ],
          hoverBackgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#4BC0C0",
            "#9966FF",
            "#FF9F40",
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#4BC0C0",
            "#9966FF",
            "#FF9F40",
          ],
        },
      ],
    });
  }, [surveyData, viewOption, selectedYear]);

  useEffect(() => {
    if (projectId) localStorage.setItem("currentProjectId", projectId);
  }, [projectId]);

  const handleClearAll = () => {
    const lastYear = surveyYears[surveyYears.length - 1] || currentYear;
    setSelectedYear(lastYear);
    setViewOption("Month");
  };

  const handleClearAllForTranslation = () => {
    const lastYear =
      translationYears[translationYears.length - 1] || currentYear;
    setSelectedYearForTranslation(lastYear);
    setViewOptionForTranslation("Month");
  };

  useEffect(() => {
    const pm = surveyData?.project_metadata || {};
    const { project_start_date, project_end_date } = pm;

    const startDate = project_start_date ? new Date(project_start_date) : null;
    const endDate = project_end_date ? new Date(project_end_date) : null;
    const today = new Date();

    let calculatedTotalDays = 0;
    let calculatedElapsedDays = 0;

    if (startDate && endDate) {
      if (selectedDate === "start") {
        calculatedTotalDays =
          (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24);
        calculatedElapsedDays =
          (today.getTime() - startDate.getTime()) / (1000 * 3600 * 24);
      } else {
        calculatedTotalDays =
          (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24);
        calculatedElapsedDays =
          (endDate.getTime() - today.getTime()) / (1000 * 3600 * 24);
      }

      setTotalDays(calculatedTotalDays);
      setElapsedDays(calculatedElapsedDays);

      const calculatedProgress = Math.min(
        Math.max((calculatedElapsedDays / calculatedTotalDays) * 100, 0),
        100,
      );
      setProgress(calculatedProgress);
    }
  }, [surveyData, selectedDate]);

  const projectMetadata = surveyData?.project_metadata || {};
  const {
    project_name = t("dashboard.noProjectName"),
    project_description,
    project_manager_name,
    country_name,
    project_start_date,
    project_end_date,
  } = projectMetadata;

  useEffect(() => {
    if (translationData) {
      const { translation_counts } = translationData;
      setPieDataTextExcelJson({
        labels: [
          t("dashboard.translationTypes.text"),
          t("dashboard.translationTypes.excel"),
          t("dashboard.translationTypes.json"),
        ],
        datasets: [
          {
            data: [
              translation_counts["text type"] || 0,
              translation_counts["excel type"] || 0,
              translation_counts["json type"] || 0,
            ],
            backgroundColor: ["#CAE2FF", "#4a90e2", "#F4D9FF"],
            hoverBackgroundColor: ["#CAE2FF", "#4a90e2", "#F4D9FF"],
          },
        ],
      });
    }
  }, [translationData]);

  const translationCounts = translationData?.translation_counts || {
    "text type": 0,
    "excel type": 0,
    "json type": 0,
  };

  const totalTranslations =
    (translationCounts["text type"] || 0) +
    (translationCounts["excel type"] || 0) +
    (translationCounts["json type"] || 0);

  const hasTranslationDataForPeriod = (
    (translationVolumeData.datasets[0]?.data as number[]) ?? []
  ).some((v) => v > 0);

  const redirectToProjectListWithEdit = () => {
    const workspaceId = localStorage.getItem("currentWorkspaceId");
    if (workspaceId) {
      navigate(`/projects/${workspaceId}`, {
        state: { projectId: projectId, openEditModal: true },
      });
    }
  };

  /* --------- Document Insights (nga store) --------- */
  const internalMediaCount = internal; // nga redux
  const externalMediaCount = external; // nga redux

  const documentInsightsPieData: ChartData<"pie", number[], string> = {
    labels: [t("dashboard.charts.internal"), t("dashboard.charts.external")],
    datasets: [
      {
        data: [internalMediaCount, externalMediaCount],
        backgroundColor: ["#4B7BFF", "#A072EB"],
        hoverBackgroundColor: ["#4B7BFF", "#A072EB"],
      },
    ],
  };

  const valueLabelPlugin: any = {
    id: "valueLabelPlugin",
    afterDatasetsDraw(chart: any) {
      const { ctx } = chart;
      ctx.save();
      chart.data.datasets.forEach((dataset: any, dsIndex: number) => {
        const meta = chart.getDatasetMeta(dsIndex);
        meta.data.forEach((bar: any, i: number) => {
          const val = dataset.data[i] ?? 0;
          ctx.font = "12px sans-serif";
          ctx.fillStyle = "#4A1C96";
          ctx.textAlign = "center";
          ctx.fillText(String(val), bar.x, bar.y - 6);
        });
      });
      ctx.restore();
    },
  };

  // ⭐ NEW: të dhënat për overview bar
  const overviewBarData = {
    labels: [
      t("dashboard.charts.overviewUsers"),
      t("dashboard.charts.overviewMedia"),
      t("dashboard.charts.overviewHighlights"),
      t("dashboard.charts.overviewCodes"),
    ],
    datasets: [
      {
        label: t("dashboard.charts.overviewTotals"),
        data: [
          summary?.total_members ?? 0,
          summary?.total_documents ?? 0,
          summary?.total_highlights ?? 0,
          summary?.total_codes ?? 0,
        ],
        backgroundColor: "#5B8CDB",
        borderColor: "#5B8CDB",
        borderWidth: 1,
      },
    ],
  };
  const overviewBarOptions: ChartOptions<"bar"> = {
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: { top: 24 } },
    plugins: { legend: { display: false }, title: { display: false } },
    scales: {
      x: { grid: { display: false } },
      y: {
        beginAtZero: true,
        grid: { color: "rgba(0,0,0,0.06)" },
        ticks: {
          callback: (value: number | string) => {
            const n = Number(value);
            if (n >= 1000) return `${n / 1000}k`;
            return n;
          },
        },
      },
    },
  };
  return (
    <div className="project-dashboard-layout" style={{ marginLeft: 0 }}>
      <Content
        className="site-layout-background"
        style={{ padding: "0 24", margin: 0, minHeight: 280 }}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: 12,
            padding: "32px 40px",
            display: "flex",
            flexDirection: "column",
            gap: 24,
          }}
        >
          <div className="first-container">
            <div className="pd-header-row">
              <div>
                <h2
                  className="project-dashboard-title"
                  style={{ marginBottom: 4 }}
                >
                  {t("dashboard.title")}
                </h2>
                <p className="pd-header-subtitle">{t("dashboard.subtitle")}</p>
              </div>
              <button
                className="pd-export-btn"
                onClick={!isLoading ? () => window.print() : undefined}
                disabled={isLoading}
              >
                <DownloadOutlined /> {t("dashboard.export")}
              </button>
            </div>

            <hr className="pd-divider" />
            <h4 className="pd-quick-actions-label">
              {t("dashboard.quickActions")}
            </h4>
            <div className="first-card-Ai">
              {[
                {
                  icon: (
                    <img
                      src={DataCleaning}
                      alt=""
                      style={{ width: 24, height: 24 }}
                    />
                  ),
                  label: t("dashboard.quickActionsList.dataCleaning"),
                  href: `/data-cleaning/${projectId}`,
                },
                {
                  icon: (
                    <img
                      src={AITranslation}
                      alt=""
                      style={{ width: 24, height: 24 }}
                    />
                  ),
                  label: t("dashboard.quickActionsList.aiTranslation"),
                  href: `/ai-translation/${projectId}`,
                },
                {
                  icon: (
                    <img
                      src={DocumentInsight}
                      alt=""
                      style={{ width: 24, height: 24 }}
                    />
                  ),
                  label: t("dashboard.quickActionsList.documentInsights"),
                  href: `/doc-processing/${projectId}`,
                },
                {
                  icon: (
                    <img
                      src={BalancedScorecard}
                      alt=""
                      style={{ width: 24, height: 24 }}
                    />
                  ),
                  label: t("dashboard.quickActionsList.balancedScorecard"),
                  href: `/balanced-scorecard/${projectId}`,
                },
              ].map(({ icon, label, href }) => (
                <a
                  key={label}
                  href={href}
                  className="ai-survey-tools-card quick-action-card"
                >
                  <span className="quick-action-icon">{icon}</span>
                  <span className="quick-action-label">{label}</span>
                  <ArrowRightOutlined className="quick-action-arrow" />
                </a>
              ))}
            </div>
          </div>

          <div className="second-innerContainer">
            {isLoading ? (
              <div style={{ color: "white" }}>{t("dashboard.loading")}</div>
            ) : (
              <>
                <div className="second-innerContainer-part">
                  <h2>{project_name}</h2>
                  <p>
                    {project_description ?? t("dashboard.defaultDescription")}
                  </p>
                  <div className="second-innerContainer-div">
                    <div className="second-innerContainer-content">
                      <img
                        src={Member}
                        alt=""
                        style={{ width: "14px", height: "14px" }}
                      />
                      <span>{project_manager_name}</span>
                    </div>
                    <div className="second-innerContainer-content">
                      <img
                        src={Location}
                        alt=""
                        style={{ width: "14px", height: "14px" }}
                      />
                      <span>{country_name}</span>
                    </div>
                  </div>
                </div>
                <div className="second-inner-content">
                  <img
                    src={EditProject}
                    alt="edit project"
                    style={{ width: "40px", height: "40px" }}
                    onClick={redirectToProjectListWithEdit}
                  />
                </div>
              </>
            )}
          </div>

          <div
            className="third-innerContainer"
            style={{ flexDirection: "column" }}
          >
            {/* Period + Timeline row */}
            <div className="pd-period-timeline-row">
              <div className="project-period-style">
                <div className="project-period-content-style">
                  <div className="project-period-innerContent">
                    <img src={ProjectPeriodIcon} alt="projectperiod" />
                    <h2>{t("dashboard.projectPeriod")}</h2>
                  </div>
                  <div className="first-date-row">
                    <Radio.Group
                      onChange={(e) => setSelectedDate(e.target.value)}
                      value={selectedDate}
                    >
                      <Radio value="start">
                        <span className="date-label">
                          {t("dashboard.startDate")}
                        </span>
                      </Radio>
                      <Radio value="end" className="end-date-radio">
                        <span className="date-label">
                          {t("dashboard.endDate")}
                        </span>
                      </Radio>
                    </Radio.Group>
                  </div>
                  <div className="first-date-row">
                    <span
                      className={`date-value ${selectedDate === "start" ? "selected" : ""}`}
                    >
                      {project_start_date}
                    </span>
                    <span
                      className={`date-value ${selectedDate === "end" ? "selected" : ""}`}
                    >
                      {project_end_date}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div className="first-progress-bar">
                      <div
                        className="progress"
                        style={{ width: `${progress}%` }}
                      ></div>
                    </div>
                    <div className="completion">
                      <span>{Math.round(progress / 10)}/10</span>
                      <br /> {t("dashboard.overallCompleted")}
                    </div>
                  </div>
                </div>
              </div>

              <div className="project-period-style">
                <div
                  style={{
                    gap: "5px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div className="project-period-innerContent">
                    <img src={Timeline} alt="projectperiod" />
                    <h2>{t("dashboard.timeline")}</h2>
                  </div>
                  <div className="remaining-time-text">
                    <span>
                      {t("dashboard.daysCount", {
                        count: Math.round(Math.max(totalDays - elapsedDays, 0)),
                      })}
                    </span>{" "}
                    {t("dashboard.remainingTime")}
                  </div>
                  <div className="progress-bar">
                    <div
                      className="progress"
                      style={{ width: `${progress}%` }}
                    ></div>
                  </div>
                  <div className="date-row">
                    <span className="date-value">
                      {project_start_date} <br />
                      {t("dashboard.start")}
                    </span>
                    <span className="date-value">
                      {project_end_date} <br />
                      {t("dashboard.end")}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* -------- Quick Stats -------- */}
            <div className="quick-stats-grid">
              {[
                {
                  label: t("dashboard.quickStats.dashboards"),
                  value: totalDashboards,
                  icon: (
                    <img
                      src={Dashboards}
                      alt=""
                      style={{ width: 50, height: 50 }}
                    />
                  ),
                  accent: "#292929",
                  bg: "#F3EEFF",
                },
                {
                  label: t("dashboard.quickStats.translations"),
                  value: totalTranslations,
                  icon: (
                    <img
                      src={AITranslationBg}
                      alt=""
                      style={{ width: 50, height: 50 }}
                    />
                  ),
                  accent: "#292929",
                  bg: "#F3EEFF",
                },
                {
                  label: t("dashboard.quickStats.documents"),
                  value: (internalMediaCount ?? 0) + (externalMediaCount ?? 0),
                  icon: (
                    <img
                      src={DocumentsBg}
                      alt=""
                      style={{ width: 50, height: 50 }}
                    />
                  ),
                  accent: "#292929",
                  bg: "#F3EEFF",
                },
                {
                  label: t("dashboard.quickStats.teamMembers"),
                  value: summary?.total_members ?? 0,
                  icon: (
                    <img
                      src={TeamMembersBg}
                      alt=""
                      style={{ width: 50, height: 50 }}
                    />
                  ),
                  accent: "#292929",
                  bg: "#F3EEFF",
                },
              ].map((stat) => (
                <div key={stat.label} className="quick-stats-card">
                  <div
                    className="quick-stats-icon"
                    style={{ backgroundColor: stat.bg, color: stat.accent }}
                  >
                    {stat.icon}
                  </div>
                  <div>
                    <div
                      className="quick-stats-value"
                      style={{ color: stat.accent }}
                    >
                      {stat.value}
                    </div>
                    <div className="quick-stats-label">{stat.label}</div>
                  </div>
                </div>
              ))}
            </div>
            {/* -------- /Quick Stats -------- */}
          </div>

          {/* -------- BSC Result -------- */}
          <div className="first-container">
            <div className="third-inner-container">
              <span className="section-pill">
                {t("dashboard.scorecardPill")}
              </span>
              <h2 className="section-title">{t("dashboard.bscResult")}</h2>

              {bscLoading ? (
                <div style={{ color: "#999", fontSize: 14, padding: "1rem 0" }}>
                  {t("dashboard.loading")}
                </div>
              ) : (
                <>
                  <div className="bsc-counts-row">
                    {[
                      {
                        label: t("dashboard.bsc.green"),
                        value: scorecard?.summary?.green ?? 0,
                        border: "1px solid #CFE9DB",
                        color: "#16a34a",
                        bg: "#fafdfb",
                      },
                      {
                        label: t("dashboard.bsc.yellow"),
                        value: scorecard?.summary?.yellow ?? 0,
                        border: "1px solid #FEEACD",
                        color: "#d97706",
                        bg: "#FFF9F0",
                      },
                      {
                        label: t("dashboard.bsc.red"),
                        value: scorecard?.summary?.red ?? 0,
                        border: "1px solid #F9D1D6",
                        color: "#dc2626",
                        bg: "#FEFAFA",
                      },
                      {
                        label: t("dashboard.bsc.indicators"),
                        value: scorecard?.summary?.total ?? 0,
                        border: "1px solid #E6E6E6",
                        color: "#1a1a2e",
                        bg: "#FFFFFF",
                      },
                    ].map((item) => (
                      <div
                        key={item.label}
                        className="bsc-count-card"
                        style={{
                          backgroundColor: item.bg,
                          border: item.border,
                        }}
                      >
                        <span className="bsc-count-label">{item.label}</span>
                        <span
                          className="bsc-count-value"
                          style={{ color: item.color }}
                        >
                          {item.value}
                        </span>
                      </div>
                    ))}
                  </div>

                  <div className="bsc-bottom-row">
                    <div className="bsc-overall">
                      <h4>{t("dashboard.bsc.overallPerformance")}</h4>
                      <div className="bsc-donut-wrapper">
                        <Doughnut
                          data={{
                            datasets: [
                              {
                                data:
                                  scorecard?.overall_score != null
                                    ? [
                                        scorecard.overall_score,
                                        100 - scorecard.overall_score,
                                      ]
                                    : [0, 100],
                                backgroundColor: [
                                  trafficColor(
                                    scorecard?.overall_traffic_light,
                                  ),
                                  "#f3f4f6",
                                ],
                                borderWidth: 0,
                              },
                            ],
                          }}
                          options={{
                            cutout: "72%",
                            plugins: {
                              legend: { display: false },
                              tooltip: { enabled: false },
                            },
                          }}
                        />
                        <div className="bsc-donut-label">
                          <span
                            className="bsc-donut-value"
                            style={{
                              color: trafficColor(
                                scorecard?.overall_traffic_light,
                              ),
                            }}
                          >
                            {scorecard?.overall_score != null
                              ? Math.round(scorecard.overall_score)
                              : 0}
                          </span>
                          <span className="bsc-donut-sub">
                            {t("dashboard.bsc.overallLabel")}
                          </span>
                        </div>
                      </div>
                      {scorecard == null ? (
                        <p
                          className="bsc-band-text"
                          style={{ textAlign: "center" }}
                        >
                          {t("dashboard.bsc.noScorecardData")}
                        </p>
                      ) : (
                        (() => {
                          const tl = scorecard.overall_traffic_light;
                          const bandLabel =
                            tl === "green"
                              ? t("dashboard.bsc.bandOnTrack")
                              : tl === "yellow"
                                ? t("dashboard.bsc.bandAtRisk")
                                : tl === "red"
                                  ? t("dashboard.bsc.bandCritical")
                                  : null;
                          const bandColor = trafficColor(tl);
                          const bandBg =
                            tl === "green"
                              ? "#dcfce7"
                              : tl === "yellow"
                                ? "#fef3c7"
                                : tl === "red"
                                  ? "#fee2e2"
                                  : "#f3f4f6";
                          return bandLabel ? (
                            <div className="bsc-band-row">
                              <span>{t("dashboard.bsc.scorecardSitsIn")}</span>
                              <span
                                className="bsc-band-pill"
                                style={{
                                  backgroundColor: bandBg,
                                  color: bandColor,
                                }}
                              >
                                <span
                                  className="bsc-band-dot"
                                  style={{ backgroundColor: bandColor }}
                                />
                                {bandLabel}
                              </span>
                            </div>
                          ) : null;
                        })()
                      )}
                    </div>

                    <div className="bsc-domains">
                      <h4>{t("dashboard.bsc.performanceByDomain")}</h4>
                      {scorecard?.domains && scorecard.domains.length > 0 ? (
                        scorecard.domains.map((d) => (
                          <div key={d.id} className="bsc-domain-row">
                            <span className="bsc-domain-label">{d.name}</span>
                            <div className="bsc-domain-bar-wrap">
                              <div
                                className="bsc-domain-bar"
                                style={{
                                  width: `${d.domain_score ?? 0}%`,
                                  backgroundColor: trafficColor(
                                    d.traffic_light,
                                  ),
                                }}
                              />
                            </div>
                            <span className="bsc-domain-score">
                              {d.domain_score != null
                                ? Math.round(d.domain_score)
                                : 0}
                            </span>
                          </div>
                        ))
                      ) : (
                        <p style={{ color: "#999", fontSize: 14 }}>
                          {t("dashboard.bsc.noDomains")}
                        </p>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          {/* -------- /BSC Result -------- */}

          {/* -------- AI Translation -------- */}
          <div className="first-container">
            <div className="third-inner-container">
              <span className="section-pill">
                {t("dashboard.translationPill")}
              </span>
              <h2 className="section-title">
                {t("dashboard.aiTranslationTitle")}
              </h2>
              <p className="section-subtitle">
                {t("dashboard.activitySnapshot")}
              </p>
              <div className="activity-snapshot-row">
                <div className="translation-counts-col">
                  {[
                    {
                      label: t("dashboard.translationTypes.text"),
                      value: translationCounts["text type"],
                    },
                    {
                      label: t("dashboard.translationTypes.excel"),
                      value: translationCounts["excel type"],
                    },
                    {
                      label: t("dashboard.translationTypes.json"),
                      value: translationCounts["json type"],
                    },
                  ].map(({ label, value }) => (
                    <div key={label} className="translation-count-card">
                      <span className="translation-count-value">{value}</span>
                      <span className="translation-count-label">{label}</span>
                    </div>
                  ))}
                </div>
                <div className="pieDataTextExcelJson-style">
                  {totalTranslations === 0 ? (
                    <span style={{ color: "#999", fontSize: 14 }}>
                      {t("dashboard.noTranslationsYet")}
                    </span>
                  ) : (
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                        height: "240px",
                      }}
                    >
                      <Pie data={pieDataTextExcelJson} options={pieOptions} />
                    </div>
                  )}
                </div>
              </div>
              <hr className="pd-divider" />
              <div className="translation-volume-overtime">
                <h2
                  style={{
                    color: "#1a1a1a",
                    fontWeight: 600,
                    margin: 0,
                    fontSize: 18,
                  }}
                >
                  {t("dashboard.volumeOverTime")}
                </h2>
                <div className="select-time-fortranslation">
                  <Select
                    value={selectedYearForTranslation}
                    onChange={(value) => setSelectedYearForTranslation(value)}
                    style={{ width: "100px" }}
                  >
                    {translationYears.map((year) => (
                      <Select.Option key={year} value={year}>
                        {year}
                      </Select.Option>
                    ))}
                  </Select>
                  <Select
                    value={viewOptionForTranslation}
                    onChange={(value) =>
                      setViewOptionForTranslation(value as "Month" | "Week")
                    }
                    style={{ width: "100px" }}
                  >
                    <Select.Option value="Month">
                      {t("dashboard.month")}
                    </Select.Option>
                    <Select.Option value="Week">
                      {t("dashboard.week")}
                    </Select.Option>
                  </Select>
                  <div style={{ display: "inline-flex", whiteSpace: "nowrap" }}>
                    <Radio.Group
                      value={chartTypeForTranslation}
                      onChange={(e) =>
                        setChartTypeForTranslation(e.target.value)
                      }
                    >
                      <Radio.Button value="bar">
                        {t("dashboard.barChart")}
                      </Radio.Button>
                      <Radio.Button value="pie">
                        {t("dashboard.pieChart")}
                      </Radio.Button>
                    </Radio.Group>
                  </div>
                </div>
              </div>
              <div
                style={{
                  border: "1px solid #E6E6E6",
                  borderRadius: "8px",
                  padding: "1.5rem 1.5rem 0",
                }}
              >
                <div
                  style={{ position: "relative", height: 300, width: "100%" }}
                >
                  {chartTypeForTranslation === "bar" ? (
                    <TranslationVolumeChart
                      data={translationVolumeData}
                      options={translationVolumeChartOptions}
                    />
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {hasTranslationDataForPeriod ? (
                        <Pie
                          data={generatedTranslationsPieData}
                          options={{
                            maintainAspectRatio: false,
                            plugins: {
                              legend: {
                                position: "right",
                                labels: {
                                  font: { size: 13 },
                                  boxWidth: 14,
                                  padding: 10,
                                },
                              },
                            },
                          }}
                        />
                      ) : (
                        <span style={{ color: "#999", fontSize: 14 }}>
                          {t("dashboard.noTranslationsForPeriod")}
                        </span>
                      )}
                    </div>
                  )}
                </div>
                <div style={{ textAlign: "end" }}>
                  <img
                    src={ReverseOrder}
                    alt="reverse ordered"
                    onClick={toggleTranslationOrder}
                    className="reverseStyleButton"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* -------- Document Insights -------- */}
          <div className="first-container">
            <div className="third-inner-container">
              <span className="section-pill">
                {t("dashboard.documentsPill")}
              </span>
              <h2 className="section-title">
                {t("dashboard.documentInsightsTitle")}
              </h2>
              <p className="section-subtitle">
                {t("dashboard.activitySnapshotCaps")}
              </p>

              <div className="activity-snapshot-row">
                <div className="translation-counts-col">
                  {[
                    {
                      label: t("dashboard.internalMedia"),
                      value: countsLoading ? "…" : internalMediaCount,
                    },
                    {
                      label: t("dashboard.externalMedia"),
                      value: countsLoading ? "…" : externalMediaCount,
                    },
                  ].map(({ label, value }) => (
                    <div key={label} className="translation-count-card">
                      <span className="translation-count-value">{value}</span>
                      <span className="translation-count-label">{label}</span>
                    </div>
                  ))}
                </div>
                <div className="pieDataTextExcelJson-style">
                  {!countsLoading &&
                  internalMediaCount === 0 &&
                  externalMediaCount === 0 ? (
                    <span style={{ color: "#999", fontSize: 14 }}>
                      {t("dashboard.noDocumentsYet")}
                    </span>
                  ) : (
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                        height: "240px",
                      }}
                    >
                      <Pie
                        data={documentInsightsPieData}
                        options={pieOptions}
                      />
                    </div>
                  )}
                </div>
              </div>

              {countsError && (
                <div style={{ color: "tomato", marginTop: 8 }}>
                  {t("dashboard.loadDocumentCountsFailed", {
                    error: countsError,
                  })}
                </div>
              )}
              <hr className="pd-divider" />

              <h2
                style={{
                  color: "#1a1a1a",
                  fontWeight: 600,
                  margin: "0 0 1rem 0",
                  fontSize: 18,
                }}
              >
                {t("dashboard.documentsOverviewTitle")}
              </h2>
              <div
                style={{
                  border: "1px solid #E6E6E6",
                  borderRadius: "8px",
                  padding: "1.5rem",
                }}
              >
                <div
                  style={{ position: "relative", height: 300, width: "100%" }}
                >
                  {summary?.loading ? (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "3rem",
                        color: "#999",
                        fontSize: 14,
                      }}
                    >
                      {t("dashboard.loading")}
                    </div>
                  ) : (
                    <Bar
                      data={overviewBarData}
                      options={overviewBarOptions}
                      plugins={[valueLabelPlugin]}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* -------- /Document Insights -------- */}
        </div>
      </Content>
    </div>
  );
};

export default ProjectDashboard;
